<template>
    <div class="transfer-person-register">
        <div class="alert alert-info" role="alert" v-if="isLoading">
            Laden...
        </div>
        <div class="accordion" v-if="groups.length > 0">
            <div class="accordion-body px-0">
                <div class="list-group list-group-flush mb-4"
                     v-bind:key="key" v-for="(group, key) in groups">
                    <div class="list-group-item fw-bold">
                        {{ group.name }}
                    </div>
                    <template v-if="group.persons && group.persons.length > 0">
                        <div class="list-group-item d-none d-md-block bg-body-tertiary border-0">
                            <div class="list-group list-group-flush">
                                <div class="list-group-item d-flex align-items-center me-4 py-0 bg-body-tertiary">
                                    <div class="container-fluid">
                                        <div class="row fw-bold">
                                            <div class="col-md-3">Naam</div>
                                            <div class="col-md-2">Geboortedatum</div>
                                            <div class="col-md-2">Geslacht</div>
                                            <div class="col-md-3">Type</div>
                                            <div class="col-md-2">Geregistreerd</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="list-group-item d-flex justify-content-between align-items-center"
                            v-bind:key="keyP" v-for="(person, keyP) in group.persons"
                        >
                            <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-12 col-md-3 text-truncate">{{ person.name }}</div>
                                        <div class="col-6 col-md-2 mobile-font-muted mobile-font-small">
                                            <span class="d-md-none fw-bold">Geboortedatum: </span>{{ $moment(person.date_of_birth).format('DD-MM-YYYY') }}
                                        </div>
                                        <div class="col-6 col-md-2 mobile-font-muted mobile-font-small">
                                            <span class="d-md-none fw-bold">Geslacht: </span>{{ person.gender }}
                                        </div>
                                        <div class="col-6 col-md-3 mobile-font-muted mobile-font-small text-truncate">
                                            <span class="d-md-none fw-bold">Type: </span>{{ person.type }}
                                        </div>
                                        <div class="col-6 col-md-2 mobile-font-muted mobile-font-small">
                                            <span class="d-md-none fw-bold">Geregistreerd: </span>
                                            <span v-if="person.registrated_in_register" class="text-success">Ja</span>
                                            <span v-else class="text-danger">Nee</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else class="list-group-item">
                        Geen structureel aanwezigen voor deze groep
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="!isLoading">
            <div class="alert alert-info">
                Geen structureel aanwezigen beschikbaar
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TransferPersonRegister',
    data() {
        return {
            isLoading: false,
            groups: []
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.isLoading = true;
            this.$request.get('/person-register', {
                params: {
                    id_group: this.$store.getters.selectedGroupsQueryString
                }
            })
            .then((response) => {
                if (response.data) {
                    this.groups = response.data
                } else {
                    this.groups = []
                }
                this.isLoading = false
            })
            .catch(() => {
                this.groups = []
                this.isLoading = false
            })
        }
    }
}
</script>

<style scoped>
</style>
